export function viewImages(imagepath, imageName) {
  const bodyMain = document.body;
  bodyMain.classList.add("active");

  const imageBox = document.getElementById("imgBoxgal");
  const img = document.createElement("img");
  img.classList.add("img-fluid");
  img.src = imagepath; // ✅ fixed to use actual path
  imageBox.appendChild(img);

  const imgText = document.getElementById("imageText");
  imgText.innerHTML = imageName;
}

document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") closeGalery();
});

export function closeGalery() {
  const bodyMain = document.body;
  bodyMain.classList.remove("active");
  const imageBox = document.getElementById("imgBoxgal");
  imageBox.innerHTML = "";
  const imgText = document.getElementById("imageText");
  imgText.innerHTML = "";
}
